/**
 * Polish user-facing labels for domain enums.
 *
 * These live in `shared` rather than in the web app because the API needs them
 * too, for e-mail subjects and bodies. Everything else in the codebase stays
 * English — this file is the deliberate exception.
 */
export const USER_ROLE_LABELS = {
    ADMIN: 'Właściciel',
    ACCOUNTANT: 'Księgowość',
    SITE_MANAGER: 'Kierownik budowy',
};
export const VENDOR_TYPE_LABELS = {
    SUPPLIER: 'Dostawca',
    SUBCONTRACTOR: 'Podwykonawca',
    OTHER: 'Inny',
};
export const INVOICE_SOURCE_LABELS = {
    MANUAL: 'Wprowadzona ręcznie',
    KSEF: 'Z KSeF',
    EMAIL: 'Z e-maila',
};
export const INVOICE_STATUS_LABELS = {
    NEW: 'Do przypisania',
    ASSIGNED: 'Czeka na kierownika',
    APPROVED_BY_MANAGER: 'U właściciela',
    DISPUTED: 'Zakwestionowana',
    APPROVED_FOR_PAYMENT: 'Zatwierdzona do zapłaty',
    PAID: 'Zapłacona',
};
export const PAYMENT_METHOD_LABELS = {
    TRANSFER: 'Przelew',
    CASH: 'Gotówka',
};
export const ADJUSTMENT_KIND_LABELS = {
    RETENTION: 'Kaucja gwarancyjna',
    CORRECTION: 'Faktura korygująca',
    DISCOUNT: 'Skonto',
    OTHER: 'Inne potrącenie',
};
/** Short labels for the site manager's phone screens, where space is tight. */
export const INVOICE_STATUS_SHORT_LABELS = {
    NEW: 'Nowa',
    ASSIGNED: 'Do akceptacji',
    APPROVED_BY_MANAGER: 'Zaakceptowana',
    DISPUTED: 'Zgłoszona uwaga',
    APPROVED_FOR_PAYMENT: 'Zatwierdzona',
    PAID: 'Zapłacona',
};
/**
 * Said from the sender's point of view, because that is who reads it: the
 * manager wants to know whether their order is on its way, not what state a
 * row in a queue is in.
 */
export const MAIL_STATUS_LABELS = {
    PENDING: 'Wysyłanie',
    SENT: 'Wysłane',
    FAILED: 'Niewysłane',
};
export const DISPUTE_REASON_LABELS = {
    WRONG_PROJECT: 'To nie moja budowa',
    QUANTITY_MISMATCH: 'Nie zgadza się ilość',
    PRICE_MISMATCH: 'Nie zgadza się cena',
    NOT_DELIVERED: 'Towar nie dotarł',
    OTHER: 'Inny powód',
};
//# sourceMappingURL=labels.js.map